import { z } from 'zod'
import type {HttpClient} from "@jantm/model-core";
import {createContactPersonApi} from "@/api/wiser/contactPerson.ts";
import {defineModel} from '@jantm/model-core'
import ContactPersonFullListItem from "@/templates/Wiser/ContactPersonFullListItem.vue";
import ContactPersonFullDetail from "@/templates/Wiser/ContactPersonFullDetail.vue";
import {
  optionalBoolSchema,
  optionalDateTimeSchema,
  optionalNumberSchema,
  optionalStringSchema
} from "@/types/global.ts";

export const contactPersonSchema = z.object({
  id: z.int(),
  "title": optionalStringSchema,
  "actief": optionalStringSchema,
  "aanhef": optionalStringSchema,
  "voorletters": optionalStringSchema,
  "voornaam": optionalStringSchema,
  "tussenvoegsel": optionalStringSchema,
  "achternaam": optionalStringSchema,
  "geslacht": optionalStringSchema,
  "functie": optionalStringSchema,
  "email": optionalStringSchema,
  "telefoonnr": optionalStringSchema,
  "gsmnr": optionalStringSchema,
  "inverse-contactonderrelatie": optionalNumberSchema,
  "added_on": optionalDateTimeSchema,
  "changed_on": optionalDateTimeSchema
})

export type ContactPerson = z.infer<typeof contactPersonSchema>

export const contactPersonCollectionSchema = z.array(contactPersonSchema)

export type ContactPersonCollection = z.infer<typeof contactPersonCollectionSchema>

export const contactPersonFilterSchema = z.object({
  fields: z.array(contactPersonSchema.keyof()).nullish().optional(),
  page: optionalStringSchema.default('1'),
  perPage: optionalStringSchema.default('25'),
  filters: optionalStringSchema,
})
export type ContactPersonFilter = z.infer<typeof contactPersonFilterSchema>

export type ContactPersonFilters = {
  id?: string
  title?: string
}

export interface CreateContactPersonModelOptions {
  client: HttpClient
  /** Override when this model does not live at `/api/contactPersons`. */
  endpoint?: string
}

export function createContactPersonModel(options: CreateContactPersonModelOptions) {
  return defineModel({
    name: 'ContactPerson',
    schema: contactPersonSchema,
    collectionSchema: contactPersonCollectionSchema,
    filterSchema: contactPersonFilterSchema,
    api: createContactPersonApi(options.client, options.endpoint),
    identify: (contactPerson: ContactPerson) => String(contactPerson.id),
    templates: { FullListItem: ContactPersonFullListItem, FullDetail: ContactPersonFullDetail },
    // toItems: (collection) => Object.entries(collection.items).map(([, v]) => v),
    // toTotal: (collection => collection.metadata?.total)
  })
}

export type ContactPersonModel = ReturnType<typeof createContactPersonModel>

declare module '@jantm/model-core' {
  interface ModelRegistry {
    ContactPerson: ContactPersonModel
  }
}
